import React, { PureComponent } from "react"

/* Constants */
import { utils } from "../constants"

/* Component Sixth */
class Sixth extends PureComponent {

    render = () => {
        const { onClick, isInsurance } = this.props

        if (isInsurance) {
            return (
                <div onClick={() => onClick()} className="game-button sixth-button mini-button">
                    +1 <span>{utils.translate("CARD")}</span>
                </div>
            )
        }

        return <div onClick={() => onClick()} className="game-button sixth-button">{utils.translate("+1 CARD")}</div>
    }

}

export default Sixth